import React, {useEffect, useState} from 'react';
import requests from '../api/requests';
import { questionTypesEndpoint } from '../api/endpoints';

export const QuestionTypesContext = React.createContext();


export const QuestionTypesContextProvider = props => {

  const [types, setTypes] = useState([]);

  useEffect(() => {
    requests.get(questionTypesEndpoint())
      .then(response => {
        if(response?.data) {
          setTypes(response.data)
        }
      })

  }, [])


  return (
    <QuestionTypesContext.Provider value={types}>
      {props.children}
    </QuestionTypesContext.Provider>
  )
}
